
export const editDialogOpen = () => {
  return {
    type: 'PROFILE_EDIT_DIALOG_OPEN'
  }
};

export const editDialogClose = () => {
  return {
    type: 'PROFILE_EDIT_DIALOG_CLOSE'
  }
};

export const editDialogSave = (data) => {
  return {
    type: 'PROFILE_EDIT_DIALOG_SAVE',
    data: data
  }
};

export const photoDialogOpen = () => {
  return {
    type: 'PROFILE_PHOTO_DIALOG_OPEN'
  }
};

export const photoDialogClose = () => {
  return {
    type: 'PROFILE_PHOTO_DIALOG_CLOSE'
  }
};

export const photoDialogSave = (url) => {
  console.log('profile actions url', url)
  return {
    type: 'PROFILE_PHOTO_DIALOG_SAVE',
    url: url
  }
};